import type { IVideoVisitRole } from "@components/organisms/videoVisit";
import { useVideoVisitStore } from "@components/organisms/videoVisit/store/videoVisitStore";
import type { ID } from "@constants";

const open = (
  id: ID,
  role: IVideoVisitRole,
  isGuest?: boolean,
  name?: string,
) => {
  if (!useVideoVisitStore.getState().open)
    useVideoVisitStore.getState().openVideoVisit(id, role, isGuest, name);
};

const close = () => {
  useVideoVisitStore.getState().closeVideoVisit();
};

export const visitHelper = { open, close };
